/* eslint-disable @typescript-eslint/ban-ts-ignore */
/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-plusplus */
/* eslint-disable import/prefer-default-export */

import { GoogleLocation } from '../types/Types';

export class GooglePlaceHelper {
  static UP = 38;

  static DOWN = 40;

  static ENTER = 13;

  static TAB = 9;

  static ESCAPE = 27;

  static LEFT = 37;

  static RIGHT = 39;

  static BACKSPACE = 8;

  static resetOptions = (locationList: any = {}, selectedIndex: number) => {
    const locationChildrenList = locationList.children;
    const listSize = locationChildrenList.length as number;
    if (locationChildrenList) {
      for (let i = 0; i < listSize; i++) {
        locationChildrenList.item(i).classList.remove('li-focused');
        locationChildrenList.item(i).classList.add('li-unfocused');
      }
    }
    if (selectedIndex > -1) {
      return selectedIndex - 1;
    }
    return -1;
  };

  static getLocationListElement = (
    showAutoC: boolean,
    tempDirectionData: any,
  ) => {
    let locationList;
    if (showAutoC) {
      locationList = (document.getElementById(
        `ui-id-30-${tempDirectionData.idDireccion}`,
      ) as unknown) as HTMLCollection;
    } else {
      locationList = (document.getElementById(
        `ui-id-29-${tempDirectionData.idDireccion}`,
      ) as unknown) as HTMLCollection;
    }
    return locationList;
  };

  static getOutPressed = (e: any) => {
    const focused = document.activeElement as HTMLInputElement;

    return (
      e.keyCode === GooglePlaceHelper.TAB ||
      e.keyCode === GooglePlaceHelper.ESCAPE ||
      e.keyCode === GooglePlaceHelper.BACKSPACE ||
      (e.keyCode === undefined &&
        focused.name !== 'codPostal' &&
        focused.name !== 'viaEntrega')
    );
  };

  static setOptionStyles = (
    locationChildrenList: any,
    selectedIndex: number,
  ) => {
    const listSize = locationChildrenList.length as number;

    if (locationChildrenList) {
      for (let i = 0; i < listSize; i++) {
        if (i === selectedIndex) {
          locationChildrenList.item(i).classList.add('li-focused');
          locationChildrenList.item(i).classList.remove('li-unfocused');
        } else {
          locationChildrenList.item(i).classList.remove('li-focused');
          locationChildrenList.item(i).classList.add('li-unfocused');
        }
      }
    }
  };

  static moveWithArrowsThrowOptions = (
    locationChildrenList: any,
    selectedIndex: number,
    e: any,
  ) => {
    const listSize = locationChildrenList.length as number;
    if (listSize && listSize > 0) {
      GooglePlaceHelper.setOptionStyles(locationChildrenList, selectedIndex);

      if (e.keyCode === GooglePlaceHelper.DOWN) {
        if (selectedIndex < listSize - 1) {
          selectedIndex += 1;
        } else {
          selectedIndex = 0;
        }
      } else if (e.keyCode === GooglePlaceHelper.UP) {
        if (selectedIndex > 0) {
          selectedIndex -= 1;
        } else {
          selectedIndex = listSize - 1;
        }
      }
      GooglePlaceHelper.setOptionStyles(locationChildrenList, selectedIndex);
    }

    return selectedIndex;
  };

  static arrowPressed = (e: any) => {
    return (
      e.keyCode === GooglePlaceHelper.DOWN || e.keyCode === GooglePlaceHelper.UP
    );
  };

  static leftAndRightArrowPressed = (e: any) => {
    return (
      e.keyCode === GooglePlaceHelper.LEFT ||
      e.keyCode === GooglePlaceHelper.RIGHT
    );
  };

  static optionSelected = (e: any) => {
    return e.keyCode === GooglePlaceHelper.ENTER;
  };

  static setLocationValue = (
    setSelectLocation: React.Dispatch<React.SetStateAction<GoogleLocation>>,
    location: GoogleLocation[],
    selectedIndex: number,
    locationRoad: GoogleLocation[],
  ) => {
    const focused = document.activeElement as HTMLInputElement;
    if (focused.name === 'codPostal') {
      setSelectLocation(location[selectedIndex]);
    } else if (focused.name === 'viaEntrega') {
      setSelectLocation(locationRoad[selectedIndex]);
    }
  };

  static buildKey = (length) => {
    let result = '';
    const characters =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  };

  static resetStylesOnMouseOver = (
    locationChildrenList: any,
    listSize: number,
  ) => {
    if (listSize > 0) {
      for (let i = 0; i < listSize; i++) {
        // eslint-disable-next-line no-unused-expressions
        locationChildrenList?.item(i)?.classList?.remove('li-focused');
        // eslint-disable-next-line no-unused-expressions
        locationChildrenList?.item(i)?.classList?.add('li-unfocused');
      }
    }
    return -1;
  };

  static addMouseOverForResetStyles = (
    locationChildrenList: any,
    listSize: number,
  ) => {
    if (locationChildrenList) {
      for (let i = 0; i < listSize; i++) {
        const li = locationChildrenList.item(i) as HTMLLIElement;
        if (li.getAttribute('listener') !== 'true') {
          li.setAttribute('listener', 'true');
          li.addEventListener('mouseover', () => {
            // @ts-ignore
            window.ev = true;
            // @ts-ignore
            window.si = 0;
            GooglePlaceHelper.resetStylesOnMouseOver(
              locationChildrenList,
              listSize,
            );
          });
          li.addEventListener('mouseout', () => {
            // @ts-ignore
            window.ev = false;
            // @ts-ignore
            window.si = -1;
          });
        }
      }
    }
  };
}
